import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../utils/i18n';
import LocationPicker from '@adsk/bim360-matrix-react-location-picker';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {issueAttributesType, locationsTreeNodesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {hasPermittedAttribute} from '../../utils/issues-helpers';

class LbsLocationInlineEdit extends PureComponent {
  render() {
    const {
      issue,
      locationsTreeNodes,
      className,
      styleType,
      isLocationsTreeLoading,
      isLocationsLoadingError,
      getDefaultLocationTree,
      isRequired,
      container
    } = this.props;
    const classes = classNames('LbsLocationInlineEdit', className);
    const locationPickerAvailableWidth = 200;

    return (
      <IssueFieldInlineEdit
        issue={issue}
        className={classes}
        data-testid={this.props['data-testid']}
        styleType={styleType}
        attributeName={ISSUE_ATTRIBUTE_NAMES.LOCATION_ID}
        label={i18n.t('new.location')}
        multiline={false}
        getDisplayValue={currentValue => (
          <LocationPicker
            selectedEventKey={currentValue}
            isLoading={isLocationsTreeLoading}
            loadingError={isLocationsLoadingError}
            locationApiPayload={locationsTreeNodes}
            readOnlyValue
            availableWidth={locationPickerAvailableWidth}
            clearable={!isRequired}
            popoverContainer={container}
          />
        )}
      >
        {(currentValue, closeEditMode, updateIssue) => (
          <LocationPicker
            selectedEventKey={currentValue}
            readOnlyValue={!hasPermittedAttribute(issue, ISSUE_ATTRIBUTE_NAMES.LOCATION_ID)}
            placeholder={i18n.t('filter.locationEnterPlaceholder')}
            searchPlaceholder={i18n.t('filter.locationSearchPlaceholder')}
            isLoading={isLocationsTreeLoading}
            loadingError={isLocationsLoadingError}
            onTryAgain={getDefaultLocationTree}
            locationApiPayload={locationsTreeNodes}
            openOnMount
            onClose={closeEditMode}
            onChange={option => {
              const newValue = option ? option.id : null;
              updateIssue(newValue);
            }}
            availableWidth={locationPickerAvailableWidth}
            clearable={!isRequired}
            popoverContainer={container}
          />
        )}
      </IssueFieldInlineEdit>
    );
  }
}

LbsLocationInlineEdit.displayName = 'LbsLocationInlineEdit';

LbsLocationInlineEdit.propTypes = {
  issue: issueAttributesType,
  isLocationsTreeLoading: PropTypes.bool,
  isLocationsLoadingError: PropTypes.bool,
  getDefaultLocationTree: PropTypes.func.isRequired,
  locationsTreeNodes: locationsTreeNodesType,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  isRequired: PropTypes.bool,
  container: PropTypes.object
};

export default LbsLocationInlineEdit;
